import dotenv from 'dotenv';
import { BaseLLM, BaseLLMConfig } from './base-llm';

dotenv.config({ quiet: true });

export interface AnthropicLLMConfig extends BaseLLMConfig {}

/**
 * AnthropicLLM class for handling AI-powered component generation and matching using Anthropic Claude
 */
export class AnthropicLLM extends BaseLLM {
	constructor(config?: AnthropicLLMConfig) {
		super(config);
	}

	protected getDefaultModel(): string {
		return 'anthropic/claude-sonnet-4-5-20250929';
	}

	protected getDefaultFastModel(): string {
		// Haiku is 75% cheaper and faster - ideal for simple tasks
		return 'anthropic/claude-haiku-4-5-20251001';
	}

	protected getDefaultApiKey(): string | undefined {
		return process.env.ANTHROPIC_API_KEY;
	}

	protected getProviderName(): string {
		return 'Anthropic';
	}
}

// Export a singleton instance
export const anthropicLLM = new AnthropicLLM();
